module.exports = __webpack_public_path__ + "static/12-3265d97ccba84f3dbce830eac55d5379.png";